import styled, { css } from "styled-components";

// import media from "styled-media-query";

export const Container = styled.div`
  position: relative;
  height: 32px;
  width: 57px;

  display: flex;

  border-radius: 8px;
  border: 1px solid outset ${({ theme }) => theme.colors.neutral.gray4};

  background-color: ${({ theme }) => theme.colors.neutral.gray8};

  padding: 4px;

  transition: all 0.3s ease-in-out;

  ${({ $active }) => {
    if ($active) {
      return css`
        background-color: ${({ theme }) => theme.colors.primary.vividCerulean};
        padding-left: 28px;
      `;
    }
  }}
`;

export const Input = styled.input`
  position: absolute;
  top: 0;
  left: 0;

  height: 32px;
  width: 57px;
  border-radius: 8px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  appearance: none;
`;

export const Slider = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.neutral.white};

  padding: 4px;
`;
